function hideProductModal() {
  const productModal = document.querySelectorAll('product-modal[open]');
  productModal && productModal.forEach((modal) => modal.hide());
}

document.addEventListener('shopify:block:select', function (event) {
  hideProductModal();
  const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest('slideshow-component');
  parentSlideshowComponent.pause();

  setTimeout(function () {
    parentSlideshowComponent.slider.scrollTo({
      left: event.target.offsetLeft,
    });
  }, 200);
});

document.addEventListener('shopify:block:deselect', function (event) {
  const blockDeselectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockDeselectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest('slideshow-component');
  if (parentSlideshowComponent.autoplayButtonIsSetToPlay) parentSlideshowComponent.play();
});

document.addEventListener('shopify:section:load', () => {
  hideProductModal();
  const zoomOnHoverScript = document.querySelector('[id^=EnableZoomOnHover]');
  if (!zoomOnHoverScript) return;
  if (zoomOnHoverScript) {
    const newScriptTag = document.createElement('script');
    newScriptTag.src = zoomOnHoverScript.src;
    zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  document.querySelectorAll(`[data-section="${event.detail.sectionId}"]`).forEach((element) => {
    element.remove();
    document.body.classList.remove('overflow-hidden');
  });
});

document.addEventListener('shopify:section:reorder', () => hideProductModal());

document.addEventListener('shopify:section:select', () => hideProductModal());

document.addEventListener('shopify:section:deselect', () => hideProductModal());

document.addEventListener('shopify:inspector:activate', () => hideProductModal());

document.addEventListener('shopify:inspector:deactivate', () => hideProductModal());

document.addEventListener("DOMContentLoaded", function() {
    var basePrice = 250; // سعر المتر المربع بالدراهم
    var widthInput = document.getElementById('width'); // إدخال العرض
    var heightInput = document.getElementById('height'); // إدخال الارتفاع
    var quantityInput = document.getElementById('Quantity-template--19178387767544__main'); // حقل الكمية الذي تود تحديثه

    // دالة لتحديث الكمية بناءً على المساحة
    function updateQuantity() {
        var width = parseFloat(widthInput.value); // قيمة العرض
        var height = parseFloat(heightInput.value); // قيمة الارتفاع

        // تحقق من صحة المدخلات (يجب أن تكون أكبر من 0)
        if (!isNaN(width) && !isNaN(height) && width > 0 && height > 0) {
            var area = width * height; // حساب المساحة
            var updatedQuantity = Math.ceil(area);  // حساب الكمية بناءً على المساحة (التقريب إلى الأعلى)
            quantityInput.value = updatedQuantity;  // تحديث قيمة حقل الكمية
            quantityInput.dispatchEvent(new Event('change')); // لضمان تحديث التغيير في Shopify
        } else {
            quantityInput.value = 1;  // إذا كانت المدخلات غير صالحة، تعيين الكمية إلى 1
            quantityInput.dispatchEvent(new Event('change')); // لضمان تحديث التغيير في Shopify
        }
    }

    // إضافة مستمع للأحداث عندما يتم إدخال قيمة جديدة في العرض أو الارتفاع
    widthInput.addEventListener('input', updateQuantity);
    heightInput.addEventListener('input', updateQuantity);
});
let slideIndex = 0;

function moveSlide(step) {
  const slides = document.querySelectorAll('.diaporama-slide');
  slideIndex += step;

  if (slideIndex < 0) {
    slideIndex = slides.length - 1;
  } else if (slideIndex >= slides.length) {
    slideIndex = 0;
  }

  updateSlidePosition();
}

function updateSlidePosition() {
  const slides = document.querySelector('.diaporama-slides');
  slides.style.transform = `translateX(-${slideIndex * 100}%)`;
}
document.addEventListener('DOMContentLoaded', function() {
  // تحديد العنصر الذي يحتوي على السعر
  let priceElement = document.querySelector('.price-per-item--current');
  
  // التحقق من وجود العنصر
  if (priceElement) {
    // إضافة "m²" إلى السعر
    priceElement.innerHTML += ' m²';
  }
});



